<template>
    <div id="cobranding">
        <div style="height:300px">合作</div>
    </div>
</template>

<script>
    export default {
        name: 'cobranding',
        data () {
		    return {
		      msg: '合作'
		    }
		  },
		//监听
		watch:{},
		
		//事件处理
		methods:{},

		//实例加载完成后
		created(){},

		//页面完成以后
		mounted:function(){},
    }
</script>

<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/cobranding.vue